
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { shinjukuGyokaiRamenShinjukuRamenTopImage } from "@src/constants/images";
import { meta as shinjukuKaijinMetaData } from "./kaijin.mdx";
export const meta = {
  path: "/media/shinjuku/gyokai_ramen",
  title: "【魚介塩ラーメン】新宿で絶品の魚を使った塩ラーメン３選をご紹介！",
  description: "ラーメンの激戦区新宿で、あっさりしたラーメンを食べたい方は、魚介の塩ラーメンがおすすめです！魚からとったダシは食べやすく、また食後もその塩ラーメンのスープを使って、お茶漬けが楽しめたりします！そんな魚介の塩ラーメンの中でも、食べログ3.7以上の新宿の人気３選をご紹介させていただきます！新宿で魚介ラーメンを探している方は必見です！",
  topImg: shinjukuGyokaiRamenShinjukuRamenTopImage,
  author: murakamiMasanori,
  tags: ["ラーメン", "新宿", "有名店", "人気店", "まとめ記事", "1人メシ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`新宿の魚介ラーメンの超人気店といえば、食べログ 3.7 以上の「麺屋海神」「らぁ麺 鳳仙花」「焼きあご塩らー麺 たかはし 」の 3 店でしょう`}</p>
    <p>{`それぞれこだわりのある魚からダシをとり、魚の旨味がギュッと凝縮したスープで作る塩ラーメンが特徴です！`}</p>
    <p>{`どんな魚でダシをとっているのか？`}<strong parentName="p"><em parentName="strong">{`残ったダシでお茶漬け？`}</em></strong>{`など、塩ラーメンならではの楽しみ方もご紹介させていただきます！`}</p>
    <h2>{`【５種の魚でダシをとる】麺屋海神`}</h2>
    <h3>{`「麺屋海神」とは？`}</h3>
    <p>{`食べログの評価も`}<strong parentName="p">{`3.77`}</strong>{`(2020 年 5 月時点)という高評価で、新宿ラメーンの中で３本の指に入れるとされている超人気店。
数々の番組にも新宿の名店として取り上げられている「麺屋 海神」ですが、新宿魚介系のラーメンとして人気のお店になります。`}</p>
    <p>{`###「麺屋 海神」澄み渡る黄金の魚介スープ
麺屋海神のスープは底まで見渡せると言われるほどの透き通ったスープになっています。
「麺屋 海神」のスープは本当に透き通っていますよね...！`}</p>
    <InstaImage postId="Bn-70YflMMp" mdxType="InstaImage" />
    <h4>{`日替わり５種の魚を仕入れあら炊きをする`}</h4>
    <p>{`このような形で壁にスープに使用している魚が張り出されています！
「麺屋 海神」では、日替わりで魚を仕入れ、それを焼いてからあら炊きをすることで風海を凝縮しているそうです！
張り紙がおおきい...！`}</p>
    <InstaImage postId="B8Y0Uc4nEqq" mdxType="InstaImage" />
    <h3>{`「麺屋 海神」のコシのある特製麺`}</h3>
    <InstaImage postId="Bpvlit8gJ-P" mdxType="InstaImage" />
    <p>{`２種類の小麦粉をブレンドし、炭で浄化した特性の水で練った特注麺を使用しているそうです！
コシを生むために、低温で熟成させてから使用しているそうで、細麺でもコシがしっかりある麺。`}</p>
    <h3>{`「麺屋 海神」の２度楽しめる食べ方？`}</h3>
    <p>{`「麺屋 海神」では、`}<strong parentName="p">{`へしこ焼おにぎり付き`}</strong>{`のメニューがあります！
これが、そのメニューです。`}</p>
    <InstaImage postId="B9wgKnbJYiK" mdxType="InstaImage" />
    <p>{`麺を食べ終わったあとに、へしこ焼おにぎりをスープに入れて、`}<strong parentName="p">{`雑炊`}</strong>{`として食べるという食べ方になります！`}</p>
    <InstaImage postId="B549SJDBMsK" mdxType="InstaImage" />
    <p>{`このようにラーメンで和風の雑炊が楽しめるのは嬉しいですよね！`}</p>
    <hr></hr>
    <LinkWithThumbnail meta={shinjukuKaijinMetaData} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【金目鯛の塩ラーメン】らぁ麺 鳳仙花`}</h2>
    <h3>{`「らぁ麺 鳳仙花」とは？`}</h3>
    <p>{`新宿にある超人気店「らぁ麺 はやし田」のセカンドブランドとして、2018 年 7 月 26 日にオープンしたのが「らぁ麺 鳳仙花」。
今まで魚介系のラーメンを提供してこなかったお店ですが、ついに新宿に出店！
金目鯛のダシをとってラーメンを提供しているお店ですが、新宿で一躍人気店に！`}</p>
    <h3>{`「らぁ麺 鳳仙花」金目鯛でダシをとったスープ`}</h3>
    <InstaImage postId="B7N4KPuAV2_" mdxType="InstaImage" />
    <p>{`黄金に輝く塩ラーメンが到着すると、金目鯛の香りが充満します…
金目鯛でとったは、生臭さがなく品のある優しい味わいになっていて、魚介が苦手な人でもこの塩ラーメンは食べられるそう。`}</p>
    <p>{`こんな感じで写真も撮れてしまう`}</p>
    <InstaImage postId="B9qLC_0pzdV" mdxType="InstaImage" />
    <h3>{`「らぁ麺 鳳仙花」の全粒粉で作る特製麺`}</h3>
    <p>{`菅野製麺製の全粒粉入り細ストレート麺をしようしており、しなやかで柔らかめの食感は、魚介系のスープによく合います！
細麺ですが小麦の風味はしっかり立っていてコシがある麺になっています！`}</p>
    <InstaImage postId="B9bRDAuBHC2" mdxType="InstaImage" />
    <h3>{`「らぁ麺 鳳仙花」の〆は金目鯛茶漬け！？`}</h3>
    <p>{`塩ラーメンを食べ終えたタイミングで、200 円で金目鯛茶漬けを注文できます！
ハマグリのと金目鯛のダシをかけ、ワサビをつけて食べる魚介系のお茶漬けはまさに絶品。`}</p>
    <InstaImage postId="B9_8Mh6gbJe" include={[3, 4]} mdxType="InstaImage" />
    <hr></hr>
    <h2>{`【焼きあごの塩ラーメン】焼きあご塩らー麺 たかはし 新宿本店`}</h2>
    <h3>{`「焼きあご塩らー麺 たかはし 」とは？`}</h3>
    <InstaImage postId="BdCAl2eDBj-" mdxType="InstaImage" />
    <p>{`全国で６店舗ほど展開していて、新宿本店では食べログの評価が 3.74(2020 年 5 月時点)と高いお店で、魚介系の塩ラーメンが人気のお店です！
西武新宿駅から`}<strong parentName="p">{`徒歩 1 分`}</strong>{`という好立地にあり、近くまでいくとお店の外にまでスープの香りが広がっています！
券売機で券を買ってから入る仕組みになっており、連日行列が立ち並んでいます。`}</p>
    <h3>{`「焼きあご塩らー麺 たかはし 」のあご(トビウオ)ダシをとったスープ`}</h3>
    <p>{`長崎県平戸産の新鮮な`}<strong parentName="p">{`あご（トビウオ）`}</strong>{`から出た魚介スープを使った魚介系の塩ラーメンになっています！
しっかりとした味わいにもかかわらず、魚介の旨味を引き出したさっぱりとした味わいになっていて、手が進む逸品。
馴染みのない魚からとった塩ラーメンはどんな味なんだろう！？と気になりますよね...！`}</p>
    <h3>{`こだわりのお米で「あごだし茶漬けに！」`}</h3>
    <InstaImage postId="Bxs5lKHly41" include={[2]} mdxType="InstaImage" />
    <p>{`契約農家から直送する「新潟こしひかり」を毎朝自社で精米し、ガス釜で艶やかに炊きあげた白めしを、残った塩ラーメンのスープと共にあごだし茶漬けにすることができます！
塩ラーメンならではのダシをふんだんに染み込ませたお茶漬けは想像するだけで美味しさが期待できますよね...！`}</p>
    <h3>{`「焼きあご塩らー麺 たかはし 」ではセットで丼が頼める！？`}</h3>
    <p>{`セットの丼を 3 種類から選べるようになってるのが特徴！
特性のお米でだべるセットの丼は絶対塩ラーメンと合って食べたいですよね！`}</p>
    <h4>{`和風チャーシュー丼`}</h4>
    <InstaImage postId="Bt0A0uQhDWy" mdxType="InstaImage" />
    <h4>{`塩だれロース丼`}</h4>
    <InstaImage postId="B9I91YdA-dO" mdxType="InstaImage" />
    <h3>{`明太しらす丼`}</h3>
    <InstaImage postId="BqJoximH-_s" include={[1]} mdxType="InstaImage" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`新宿の魚介系の塩ラーメンを厳選して３選紹介してきましたが、いかがでしたでしょうか？
それぞれの魚介でとった特性のダシで作った塩ラーメン、さらにはお茶漬けの楽しみ方などをご紹介させていただきました！
是非、新宿でさっぱりしたラーメンを食べたいときは、参考にしてください。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;